import { useContext } from 'react';
import { PlayerCtx, type PlayerContextValue } from './playerCtx';

export function usePlayer(): PlayerContextValue {
  const ctx = useContext(PlayerCtx);
  if (!ctx) throw new Error('usePlayer must be used within PlayerProvider');
  return ctx;
}

export function usePlayerOptional(): PlayerContextValue | null {
  return useContext(PlayerCtx);
}
